const UNSAVED_CHANGES_EVENT = 'smart-unsaved-changes-change'
const DATA_SAVED_EVENT = 'smart-data-saved'
const REQUEST_UNSAVED_CHANGES_CONFIRMATION_EVENT = 'smart-request-unsaved-changes-confirmation'

// Simple global flag. The guard is mounted once, but many components can update it.
let hasPendingChanges = false

const emitUnsavedChangesChange = () => {
  window.dispatchEvent(new CustomEvent(UNSAVED_CHANGES_EVENT, { detail: { hasPendingChanges } }))
}

export const markUnsavedChanges = () => {
  // Avoid sending the same event again if we are already dirty.
  if (hasPendingChanges) return
  hasPendingChanges = true
  emitUnsavedChangesChange()
}

export const clearUnsavedChanges = () => {
  // Same here, no need to notify if it was already clean.
  if (!hasPendingChanges) return
  hasPendingChanges = false
  emitUnsavedChangesChange()
}

export const getHasUnsavedChanges = () => hasPendingChanges

export const notifyDataSaved = () => {
  // Used by components that want to say: save is done, clean the guard.
  window.dispatchEvent(new CustomEvent(DATA_SAVED_EVENT))
}

export const requestUnsavedChangesConfirmation = (onConfirm) => {
  // Components without route navigation can request the same confirm dialog.
  if (!hasPendingChanges) return true

  window.dispatchEvent(new CustomEvent(REQUEST_UNSAVED_CHANGES_CONFIRMATION_EVENT, { detail: { onConfirm } }))
  return false
}

export const subscribeUnsavedChanges = (callback) => {
  // Small pub/sub using window events to avoid adding a provider.
  const handler = (event) => callback(event.detail.hasPendingChanges)
  window.addEventListener(UNSAVED_CHANGES_EVENT, handler)
  return () => window.removeEventListener(UNSAVED_CHANGES_EVENT, handler)
}

export const subscribeDataSaved = (callback) => {
  window.addEventListener(DATA_SAVED_EVENT, callback)
  return () => window.removeEventListener(DATA_SAVED_EVENT, callback)
}

export const subscribeUnsavedChangesConfirmationRequest = (callback) => {
  const handler = (event) => callback(event.detail.onConfirm)
  window.addEventListener(REQUEST_UNSAVED_CHANGES_CONFIRMATION_EVENT, handler)
  return () => window.removeEventListener(REQUEST_UNSAVED_CHANGES_CONFIRMATION_EVENT, handler)
}
